<div class="exception-body error">
    <div class="exception-content">
        <div class="exception-title">ERROR</div>
        <div class="exception-detail">Something went wrong.</div>
        <a [routerLink]="['/']">Go to Dashboard</a>
    </div>
</div>
